import React from 'react'

export default ({ id, ...props }) => (
  <div>
    <button 
      type="submit"  
      id={id} 
      {...props}
    />
  </div>
)


// WEBPACK FOOTER //
// ./src/views/shared/submit.js